<template>
  <template v-if="isHeading">
    <component :is="type" v-if="translate === false" class="headline" :class="styleClass">{{ text }}</component>
    <component
      :is="type"
      v-else
      class="headline"
      :class="styleClass"
      v-html="dynamicTranslation ? $t(text || '', dynamicTranslation) : $t(text || '')"
    />
  </template>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { AHeadlineProps } from './a-headline-props'

const props = withDefaults(defineProps<AHeadlineProps>(), { translate: true })
const isHeading = computed(() => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(props.type ?? ''))
</script>
